import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
  
  type Question = {
    question: string;
    explanation: string;
    attachment: string;
    figure: string[];
  }
  
  type QuizDTO = {
    title: string;
    chapterId:string;
    lectureId:string;
    OpenLectureId:string;
    QuestionEssay: Question[];
  } & ApiError

export const CreateEssayQuiz = (data: QuizDTO): Promise<QuizDTO> => {
    return axios.post("/essay/create", data)
        .then(response => response.data as QuizDTO);
};
